import AScene from "./AScene.js";

export default class AEmitter extends Phaser.GameObjects.Particles.ParticleEmitter
{
    /**
     * @param {AScene} scene 
     */
    constructor(scene, properties, frame = null, atlas = null)
    {
        let manager = new Phaser.GameObjects.Particles.ParticleEmitterManager(scene, atlas == null ? scene.defaultAtlas : atlas, frame);
        super(manager, properties);
        manager.emitters.add(this);

        this.scene = scene;
        //this.scaleX.onUpdate = this.scaleX.defaultUpdate;
        this.originalUpdate = this.preUpdate;
        this.preUpdate = (time, deltaTime)=>{ this.originalUpdate(time, deltaTime); this.update(time, deltaTime); };
    }

    fadeInOut(maxVal = 1, easeFunc = Phaser.Math.Easing.Linear)
    {
        this.setAlpha((p, k, t)=>{
            return easeFunc(maxVal - (maxVal * 2) * Math.abs(t - (maxVal * .5)));
        });
    }

    scaleInOut(maxVal = 1, easeFunc = Phaser.Math.Easing.Linear)
    {
        this.setScale((p, k, t)=>{
            return easeFunc(maxVal - (maxVal * 2) * Math.abs(t - (maxVal * .5)));
        });
    }

    setTint(from, to, easeFunc = Phaser.Math.Easing.Linear)
    {
        this.tintFunc = ()=>{
            
            this.forEachAlive((p, e)=>{
                let fromCol = Phaser.Display.Color.IntegerToColor(from);
                let toCol = Phaser.Display.Color.IntegerToColor(to);
                p.tint = Phaser.Display.Color.ObjectToColor(Phaser.Display.Color.Interpolate.ColorWithColor(toCol, fromCol, 1, easeFunc(p.lifeCurrent / p.life))).color;
            });
        };
    }

    update(time, deltaTime)
    {
        //console.log("UPDATING");
        if(this.tintFunc) this.tintFunc();
    }
}